<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6VRMqp/tc-custom/9781449423216.jpg?1709697143816" alt="This image is the cover for the book Zombies Need Love Too"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zombies Need Love Too
      </h1>
      <p class="bookDescription body article font2">
        <p>"... Mark Tatulli's Lio isn't just a charmingly macabre strip about a creepy little boy who dabbles in the occult; it's also a daily demonstration of how a skilled artist can express sometimes complicated comedic ideas without any dialogue. . . ."— <i>A.V. Club, The Onion</i><br/><br/>Lio is a small boy with a penchant for befriending squids, monsters,  and aliens. He's a curious scientist, a comic-book fan, defender of  the defenseless, and creator of an army of zombie bunnies. All without  saying a word. <i>Zombies Need Love Too</i> is Lio's fifth book with AMP.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Tatulli
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15d8c4ca